var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b2b-policy-type-dialog',{attrs:{"links":_vm.policyTypesArray,"hideButton":true,"toDisplay":_vm.toDisplay},on:{"changeDialog":_vm.changeDialog}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-141b3374","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/elements/PolicyDialogCustom.vue
// module id = AKuw
// module chunks = 0